module.exports = __webpack_public_path__ + "media/images/icon_ha_gray-5a194708a2c09c765d701a8f740a018c.png";